module.exports = __webpack_public_path__ + "media/shared/assets/img/icon_gold_transparent-6fdb297e7b28f3036f88907623b9651e.png";